// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__13-n4","title":"FrontImage_title__GC3gX"};